export const Assessment = {
    VALID: 'valid',
    UNFAIR: 'unfair',
    VOID: 'void',
}